import { faRobot, faAddressBook, faBuilding, faHandshake, faBullhorn, faCommentDots, faFolderOpen, faListCheck, faBook, faComments, faUser, faBuildingUser, faGear, faRightFromBracket, faFileSignature, faEnvelopeOpenText } from "@fortawesome/free-solid-svg-icons";

/**
 * Sidebar menu configuration.
 * Add new menu items here — each gets its own page module.
 * The sidebar renders this array; routing reads from it.
 */

export const MAIN_MENU = [
  {
    id: "ai",
    title: "My Magic",
    icon: faRobot,
    path: "/ai",
  },
  {
    id: "addressbook",
    title: "Contacts",
    icon: faAddressBook,
    path: "/addressbook",
  },
  {
    id: "properties",
    title: "Properties",
    icon: faBuilding,
    path: "/properties",
  },
  {
    id: "match",
    title: "Match",
    icon: faHandshake,
    path: "/match",
  },
  {
    id: "campaigns",
    title: "Campaigns",
    icon: faBullhorn,
    path: "/campaigns",
  },
  {
    id: "deals",
    title: "Deals",
    icon: faFileSignature,
    path: "/deals",
  },
  {
    id: "loans",
    title: "Loan Inbox",
    icon: faEnvelopeOpenText,
    path: "/loans",
  },
  {
    id: "feedback",
    title: "Feedback",
    icon: faCommentDots,
    path: "/feedback",
  },
  {
    id: "files",
    title: "Files",
    icon: faFolderOpen,
    path: "/files",
  },
  {
    id: "todo",
    title: "ToDo",
    icon: faListCheck,
    path: "/todo",
  },
  {
    id: "journal",
    title: "Journal",
    icon: faBook,
    path: "/journal",
  },
  {
    id: "aichat",
    title: "AI Chat",
    icon: faComments,
    path: "/aichat",
  },
];

export const USER_MENU = [
  {
    id: "profile",
    title: "Profile",
    icon: faUser,
    action: "popup",
  },
  {
    id: "company",
    title: "Company",
    icon: faBuildingUser,
    action: "popup",
  },
  {
    id: "settings",
    title: "Settings",
    icon: faGear,
    action: "popup",
  },
  {
    id: "logout",
    title: "Logout",
    icon: faRightFromBracket,
    action: "logout",
  },
];
